<template>
  <div class="kitchenWap">
    <div class="livingRoomSpace">
      <div class="jianbianq" :class="{'jianbianh':issjmx}" ref="sjmx">
        <div class="founder spaceCustomization">
          <div class="yishu marginTX"></div>
          <div class="beijing pwjstrone">Living room</div>
          <p v-html="seriesIntroduce.roomSpaceEng" class="kjjianjie"></p>
          <!-- <div class="moreBut">了解更多</div> -->
        </div>

        <div class="jianbianq" :class="{'jianbianh':isBaiyuefuLivingRoom}" ref="baiyuefuLivingRoom">
          <div class="spaceCustomization_img homeDecoration baiyuefuLivingRoom" ref="baiyuefuLivingRoom"
               @mouseenter="baiyuefuEnter" @mouseleave="baiyuefuLeave">
            <img :src="'https://www.vifa.cn' + baiyuefuLivingRoomImg" alt=""/>
            <div class="dingwei" :class="{'dingweishow':isBaiyuefuDingwei}">
              <div class="dingweia" @click="showBaiyuefuDetailA">+</div>
              <div class="dingweib" @click="showBaiyuefuDetailB">+</div>
              <div class="dingweic" @click="showBaiyuefuDetailC">+</div>
              <div class="dingweid" @click="showBaiyuefuDetailD">+</div>
            </div>
            <div class="dwzhankai" v-show="isBaiyuefuDetailOpen == index" v-for="(item,index) in baiyuefuDetailData"
                 :key='index' @click="closeBaiyuefuDetail">
              <ul>
                <li>
                  <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                  <div>{{ item.titleEng }}</div>
                  <p>{{ item.introduceEng }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="hscttitle pwjstrone">Park Hyatt House Living Room</div>
          <router-link :to="{path:'/productDtails',query:{title:'柏悦府客厅'}}">
            <div class="moreBut">Learn More</div>
          </router-link>
        </div>

      </div>
      <div class="jianbianq" :class="{'jianbianh':isbrandConcepttitle}" ref="brandConcepttitle">
        <div class="spaceCustomization_img homeDecoration hsct" ref="homeDecoration" @mouseenter="homeDM"
             @mouseleave="homeDMout">
          <img src="@/common/image/kala.png" alt="">
          <div class="dingwei" :class="{'dingweishow':isdingwei}">
            <div class="dingweia" @click="hsctdingweia">+</div>
            <div class="dingweib" @click="hsctdingweib">+</div>
            <div class="dingweic" @click="hsctdingweic">+</div>
            <div class="dingweid" @click="hsctdingweid">+</div>
            <div class="dingweie" @click="hsctdingweie">+</div>
          </div>
          <div class="dwzhankai" v-show="isdwzhankai == index" v-for="(item,index) in dwzhankaiData" :key='index'
               @click="dwguanbi">
            <ul>
              <li>
                <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                <div>{{ item.titleEng }}</div>
                <p>{{ item.introduceEng }}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="hscttitle pwjstrone">Calacatte Gold Audio-Visual Cabinets with Sintered Stone</div>
        <router-link
            :to="{path:'/productDtails',query:{title:'卡拉金岩板视听柜',SpaceActiv:0,ittitle:'Armadio audiovisivo in ardesia oro Kara',entitle:'Calacatte Gold Audio-Visual Cabinets with Sintered Stone'}}">
          <div class="moreBut">Learn More</div>
        </router-link>
      </div>
      <div class="jianbianq" :class="{'jianbianh':iskjmx}" ref="kjmx">
        <div class="spaceCustomization_img homeDecoration cfct" ref="homeDecoration" @mouseenter="cfctenter"
             @mouseleave="cfctleave">
          <img src="@/common/image/ktroom2.png" alt="">
          <div class="dingwei" :class="{'dingweishow':iscfctdingwei}">
            <div class="dingweia" @click="cfctdingweia">+</div>
            <div class="dingweib" @click="cfctdingweib">+</div>
            <div class="dingweic" @click="cfctdingweic">+</div>
          </div>
          <div class="dwzhankai" v-show="iscfctdwzhankai == index" v-for="(item,index) in cfctdwzhankaiData"
               :key='index' @click="cfctdwguanbi">
            <ul>
              <li>
                <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                <div>{{ item.titleEng }}</div>
                <p>{{ item.introduceEng }}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="hscttitle pwjstrone">Metal glass side cabinet</div>
        <router-link
            :to="{path:'/productDtails',query:{title:'金属玻璃边柜',SpaceActiv:0,ittitle:'Armadio laterale in vetro metallico',entitle:'Metal glass side cabinet'}}">
          <div class="moreBut">Learn More</div>
        </router-link>
      </div>
      <!-- <div class="spaceCustomization_img homeDecoration fcscf" ref="homeDecoration" @mouseenter="fcscftenter" @mouseleave="fcscftleave">
          <img src="@/common/image/ktroom3.png" alt="">
          <div class="dingwei" v-show="isfcscftdingwei">
              <div class="dingweia" @click="fcscftdingweia">+</div>
              <div class="dingweib" @click="fcscftdingweib">+</div>
              <div class="dingweic" @click="fcscftdingweic">+</div>
          </div>
          <div class="dwzhankai" v-show="isfcscftdwzhankai == index" v-for="(item,index) in fcscftdwzhankaiData" :key='index' @click="fcscftdwguanbi">
              <ul>
                  <li>
                      <img class="cfimg" :src=item.img alt="">
                      <div>{{item.name}}</div>
                      <p>{{item.text}}</p>
                  </li>
              </ul>
          </div>
      </div>
      <div class="hscttitle">卡拉金别墅客厅柜</div>
      <router-link :to="{path:'/productDtails',query:{title:'卡拉金别墅客厅柜'}}"><div class="moreBut">了解更多</div></router-link> -->
    </div>
  </div>
</template>

<script>
import {getProductDetails} from "@/api/api";


export default {
  name: 'livingRoomSpace',
  data() {
    return {
      dwzhankaiData: [],
      isdwzhankai: 999,
      isdingwei: false,
      cfctdwzhankaiData: [],
      iscfctdwzhankai: 999,
      iscfctdingwei: false,
      isfcscftdwzhankai: 999,
      isfcscftdingwei: false,
      isbrandConcepttitle: false,
      issjmx: false,
      iskjmx: false,
      baiyuefuLivingRoomImg: null,
      baiyuefuDetailData: [], // 柏悦府客厅的详细数据
      isBaiyuefuDetailOpen: 999, // 控制柏悦府客厅详情展开
      isBaiyuefuDingwei: false, // 控制柏悦府客厅定位点显示
      isBaiyuefuLivingRoom: true, // 控制柏悦府客厅的显示隐藏
    }
  },
  components: {},
  props: {
    seriesIntroduce: {
      type: String
    },
    seriesList: {
      type: Array
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.isbrandConcepttitle = true
    this.issjmx = true
    this.getkalajinyanData()
    this.getcfctdwzhankaiData()
    this.getBaiyuefuLivingRoomData()
  },
  methods: {
    getBaiyuefuLivingRoomData() {
      let data = {
        productName: "柏悦府客厅"
      }
      getProductDetails(data).then(res => {
        this.baiyuefuLivingRoomImg = res.productSeries.image
        this.baiyuefuDetailData = res.productSpecific;
      }).catch(res => {
        console.log(res)
      })
    },
    getkalajinyanData() {
      let data = {
        productName: "卡拉金岩板视听柜"
      }
      getProductDetails(data)
          .then(res => {
            this.dwzhankaiData = res.productSpecific
          })
          .catch(res => {
            console.log(res)
          })
    },
    getcfctdwzhankaiData() {
      let data = {
        productName: "金属玻璃边柜"
      }
      getProductDetails(data)
          .then(res => {
            this.cfctdwzhankaiData = res.productSpecific
          })
          .catch(res => {
            console.log(res)
          })
    },
    handleScroll() {
      this.$nextTick(() => {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
        // if (e.deltaY>0) {
        if (this.$refs.brandConcepttitle.offsetTop > this.scroll + document.documentElement.clientHeight) {
          this.isbrandConcepttitle = false
        }
        if (this.$refs.sjmx.offsetTop > this.scroll + document.documentElement.clientHeight) {
          this.issjmx = false
        }
        if (this.$refs.brandConcepttitle.offsetTop < this.scroll + document.documentElement.clientHeight) {
          this.isbrandConcepttitle = true
        }
        if (this.$refs.sjmx.offsetTop < this.scroll + document.documentElement.clientHeight) {
          this.issjmx = true
        }
        if (this.$refs.kjmx.offsetTop < this.scroll + document.documentElement.clientHeight) {
          this.iskjmx = true
        }

        // }else if (e.deltaY < 0) {
        if (this.$refs.brandConcepttitle.offsetTop > this.scroll + document.documentElement.clientHeight - 200) {
          this.isbrandConcepttitle = false
        }
        if (this.$refs.sjmx.offsetTop > this.scroll + document.documentElement.clientHeight - 200) {
          this.issjmx = false
        }
        if (this.$refs.kjmx.offsetTop > this.scroll + document.documentElement.clientHeight - 200) {
          this.iskjmx = false
        }
      })
      // }
    },
    homeDM() {
      this.isdingwei = true
    },
    homeDMout() {
      this.isdingwei = false
    },
    dwguanbi() {
      this.isdwzhankai = 999
    },
    hsctdingweia() {
      this.isdwzhankai = 0
    },
    hsctdingweib() {
      this.isdwzhankai = 1
    },
    hsctdingweic() {
      this.isdwzhankai = 2
    },
    hsctdingweid() {
      this.isdwzhankai = 3
    },
    hsctdingweie() {
      this.isdwzhankai = 4
    },
    cfctenter() {
      this.iscfctdingwei = true
    },
    cfctleave() {
      this.iscfctdingwei = false
    },
    cfctdwguanbi() {
      this.iscfctdwzhankai = 999
    },
    cfctdingweia() {
      this.iscfctdwzhankai = 0
    },
    cfctdingweib() {
      this.iscfctdwzhankai = 1
    },
    cfctdingweic() {
      this.iscfctdwzhankai = 2
    },
    fcscftenter() {
      this.isfcscftdingwei = true
    },
    fcscftleave() {
      this.isfcscftdingwei = false
    },
    fcscftdwguanbi() {
      this.isfcscftdwzhankai = 999
    },
    fcscftdingweia() {
      this.isfcscftdwzhankai = 0
    },
    fcscftdingweib() {
      this.isfcscftdwzhankai = 1
    },
    fcscftdingweic() {
      this.isfcscftdwzhankai = 2
    },
    baiyuefuEnter() {
      this.isBaiyuefuDingwei = true;
    },
    baiyuefuLeave() {
      this.isBaiyuefuDingwei = false;
    },
    closeBaiyuefuDetail() {
      this.isBaiyuefuDetailOpen = 999;
    },
    showBaiyuefuDetailA() {
      this.isBaiyuefuDetailOpen = 0;
    },
    showBaiyuefuDetailB() {
      this.isBaiyuefuDetailOpen = 1;
    },
    showBaiyuefuDetailC() {
      this.isBaiyuefuDetailOpen = 2;
    },
    showBaiyuefuDetailD() {
      this.isBaiyuefuDetailOpen = 3;
    },
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  }
}
</script>

<style scoped>
.kitchenWap .spaceCustomization p {
  /* width: 740px; */
  margin: 0 auto;
  white-space: pre-wrap;
  /* text-align: left; */
}

.hsct .dingwei .dingweia {
  left: 25%;
  top: 51%;
}

.hsct .dingwei .dingweib {
  left: 30%;
  top: 34%;
}

.hsct .dingwei .dingweic {
  left: 48%;
  top: 30%;
}

.hsct .dingwei .dingweid {
  left: 52%;
  top: 45%;
}

.hsct .dingwei .dingweie {
  left: 58%;
  top: 61%;
}

.kitchenWap .dwzhankai ul {
  width: 875px;
  height: 710px;
}

.kitchenWap .dwzhankai ul li .cfimg {
  width: 400px;
  height: 352.5px;
  margin: 88px 0 25px 355px;
}

.kitchenWap .dwzhankai ul li div {
  font-size: 30px;
  padding-top: 0;
}

.kitchenWap .dwzhankai ul li p {
  padding-top: 15px;
  font-size: 16px;
}

.hscttitle {
  font-size: 30px;
  text-align: center;
  padding-top: 60px;
  padding-bottom: 60px;
}

.cfct .dingwei .dingweia {
  left: 29.5%;
  top: 44%;
}

.cfct .dingwei .dingweib {
  left: 39%;
  top: 24%;
}

.cfct .dingwei .dingweic {
  left: 50%;
  top: 74%;
}

.fcscf .dingwei .dingweia {
  left: 34%;
  top: 46%;
}

.fcscf .dingwei .dingweib {
  left: 39.6%;
  top: 86%;
}

.fcscf .dingwei .dingweic {
  left: 50%;
  top: 73%;
}

.baiyuefuLivingRoom .dingwei .dingweia {
  left: 90%; /* 柏悦府客厅 */
  top: 35%;
}

.baiyuefuLivingRoom .dingwei .dingweib {
  left: 13%;
  top: 10%;
}

.baiyuefuLivingRoom .dingwei .dingweic {
  left: 24%;
  top: 31%;
}

.baiyuefuLivingRoom .dingwei .dingweid {
  left: 78%;
  top: 30%;
}
</style>
